import React, { useEffect } from "react";
import { Box } from "@catchoftheday/cg-components";
import { ThemeProvider, useMedia, useTheme } from "@catchoftheday/theme";
import { LoadingSpinner } from "@search-app/components/LoadingSpinner";
import { useDispatch, useShallowSelector } from "@search-app/store";
import { searchFetch } from "@search-app/store/search/actions";
import { hasFacets, isInitialSearch, isSearchLoading, relatedCategories } from "@search-app/store/search/selectors";
import { SearchFacetsModal } from "./SearchFacetsModal/";
import { HeaderContent } from "./HeaderContent";
import { Results } from "./Results";
import { SearchContainer } from "./SearchContainer";
import { SearchMigrationNudge } from "./SearchMigrationNudge";
import { SearchPillNavigation } from "./SearchPillNavigation";
import { Sidebar } from "./Sidebar";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var Search = function Search() {
  var theme = useTheme();
  var dispatch = useDispatch();

  var _useReduxState = useReduxState(),
      hasFacets = _useReduxState.hasFacets,
      isInitialSearch = _useReduxState.isInitialSearch,
      isLoading = _useReduxState.isLoading,
      relatedCategories = _useReduxState.relatedCategories;

  useEffect(function () {
    function handleRouteChange() {
      dispatch(searchFetch());
    }

    window.addEventListener("popstate", handleRouteChange);
    return function () {
      return window.removeEventListener("popstate", handleRouteChange);
    };
  }, [dispatch]);
  var isMobile = useMedia(["(max-width: ".concat(theme.breakpoints.md, ")")], [true]);
  var showSpinner = isLoading && !isInitialSearch;
  return ___EmotionJSX(ThemeProvider, {
    enableGlobalFontConfig: false
  }, showSpinner ? ___EmotionJSX(LoadingSpinner, null) : null, isMobile && ___EmotionJSX(SearchFacetsModal, null), ___EmotionJSX(Box, null, ___EmotionJSX(SearchMigrationNudge, null), ___EmotionJSX(HeaderContent, null), relatedCategories && relatedCategories.length > 0 && ___EmotionJSX(SearchPillNavigation, {
    items: relatedCategories
  }), ___EmotionJSX(SearchContainer, {
    hasFacetsModal: isMobile,
    hasFacets: hasFacets
  }, ___EmotionJSX(Sidebar, null), ___EmotionJSX(Results, null))));
};

var useReduxState = function useReduxState() {
  return useShallowSelector(function (state) {
    return {
      hasFacets: hasFacets(state),
      isLoading: isSearchLoading(state),
      isInitialSearch: isInitialSearch(state),
      relatedCategories: relatedCategories(state)
    };
  });
};